
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as component_45stubr38nDkGl_Awc52Okia_H4__4dZVMGkd_2pba9gIQ9EI } from "/home/snaumann/Development/public_html/ludwig-pfeiffer/site/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7_supports-color@10.2.2___@_d9475560e83a2a1ab749ec1fbc0c7f46/node_modules/nuxt/dist/pages/runtime/component-stub.js";
import { default as component_45stubr38nDkGl_Awc52Okia_H4__4dZVMGkd_2pba9gIQ9EIMeta } from "/home/snaumann/Development/public_html/ludwig-pfeiffer/site/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7_supports-color@10.2.2___@_d9475560e83a2a1ab749ec1fbc0c7f46/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
export default [
  {
    name: "intranet:kategorie-category_slug",
    path: "/intranet/kategorie/:category_slug()",
    meta: {"middleware":"auth"},
    component: () => import("/home/snaumann/Development/public_html/ludwig-pfeiffer/intranet/app/pages/kategorie/[category_slug].vue").then((m) => Object.assign(m.default, { __name: "intranet:kategorie-category_slug" }))
  },
  {
    name: "joboffer-detail",
    path: "/stellenangebote/:joboffer_slug()",
    component: () => import("/home/snaumann/Development/public_html/ludwig-pfeiffer/site/app/pages/stellenangebote/[joboffer_slug].vue").then((m) => Object.assign(m.default, { __name: "joboffer-detail" }))
  },
  {
    name: "intranet:dashboard",
    path: "/intranet",
    meta: {"middleware":"auth"},
    component: () => import("/home/snaumann/Development/public_html/ludwig-pfeiffer/intranet/app/pages/dashboard.vue").then((m) => Object.assign(m.default, { __name: "intranet:dashboard" }))
  },
  {
    name: "intranet:login",
    path: "/intranet/login",
    component: () => import("/home/snaumann/Development/public_html/ludwig-pfeiffer/intranet/app/pages/login.vue").then((m) => Object.assign(m.default, { __name: "intranet:login" }))
  },
  {
    name: "intranet:suche",
    path: "/intranet/suche",
    meta: {"middleware":"auth"},
    component: () => import("/home/snaumann/Development/public_html/ludwig-pfeiffer/intranet/app/pages/suche.vue").then((m) => Object.assign(m.default, { __name: "intranet:suche" }))
  },
  {
    name: "test-error",
    path: "/test-error",
    component: () => import("/home/snaumann/Development/public_html/ludwig-pfeiffer/site/app/pages/test-error.vue").then((m) => Object.assign(m.default, { __name: "test-error" }))
  },
  {
    name: "article-detail",
    path: "/:article_slug()",
    component: () => import("/home/snaumann/Development/public_html/ludwig-pfeiffer/site/app/pages/[article_slug].vue").then((m) => Object.assign(m.default, { __name: "article-detail" }))
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/home/snaumann/Development/public_html/ludwig-pfeiffer/site/app/pages/[...slug].vue").then((m) => Object.assign(m.default, { __name: "slug" }))
  },
  {
    name: "home",
    path: "/",
    component: () => import("/home/snaumann/Development/public_html/ludwig-pfeiffer/site/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: "home" }))
  },
  {
    name: component_45stubr38nDkGl_Awc52Okia_H4__4dZVMGkd_2pba9gIQ9EIMeta?.name,
    path: "/sitemap.xml",
    component: Object.assign(component_45stubr38nDkGl_Awc52Okia_H4__4dZVMGkd_2pba9gIQ9EI, { __name: component_45stubr38nDkGl_Awc52Okia_H4__4dZVMGkd_2pba9gIQ9EIMeta?.name })
  }
]